import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import HMI from '../assets/safety/safety-device.png';
import { FaHome } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';

const SISafetyDevices = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Safety</Breadcrumb.Item>
							<Breadcrumb.Item active>Safety Devices</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Emergency Stop Pushbuttons" className="mb-3">
								<Tab eventKey="Emergency Stop Pushbuttons" title="Emergency Stop Pushbuttons">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>EMERGENCY STOP PUSH BUTTONS</h2>
											<p>Detented emergency stop (E-Stop) pushbuttons are provided to interrupt equipment motion in case of an emergency. Press in the red emergency stop palm button to immediately stop station movement when danger to employees or damage to the equipment is eminent. </p>
											<p>When an E-Stop pushbutton is pressed, all power to the outputs within the station where the Estop was pressed is removed. A pressed E-stop will create a fault condition. The activation of the E-Stop pushbuttons will bring the machine to an Emergency Stop irrespective of the position in the machine cycle.</p>
											<p>A controlled stop will be applied to all machine elements, using regenerative power where applicable.</p>
											<ul>
												<li>Electrical power to all motors will be removed.</li>
												<li>Services will be switched off.</li>
												<li>“Control On” power will be maintained.</li>
											</ul>
											<div class="warning">
												<p>
													Emergency Stop devices are <b>NOT</b> an acceptable substitute for the proper application of Lockout and Tagout (<b>LOTO</b>) procedures.
												</p>
											</div>
										</div>

										<figure>
											<img src={HMI} alt="System Control Console" style={{ width: '100%' }} />
											<figcaption>Figure 1: System Control Console Buttons</figcaption>
										</figure>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SISafetyDevices;
